import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const MinusSmall = () => /*#__PURE__*/_jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  children: /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6665 8.66659H3.33317C2.96498 8.66659 2.6665 8.36811 2.6665 7.99992C2.6665 7.63173 2.96498 7.33325 3.33317 7.33325H12.6665V7.33325C13.0347 7.33325 13.3332 7.63173 13.3332 7.99992C13.3332 8.36811 13.0347 8.66659 12.6665 8.66659Z"
  })
});